import { registerPlugin } from '@capacitor/core';
const DozeOptimize = registerPlugin('DozeOptimize', {
    web: () => import('./web').then(m => new m.DozeOptimizeWeb()),
});
export * from './definitions';
export { DozeOptimize };
//# sourceMappingURL=index.js.map